import styles from './StatusDot.module.css';

type StatusDotVariant = 'ok' | 'warn' | 'err' | 'loading';

type StatusDotProps = {
  readonly variant: StatusDotVariant;
};

const StatusDot = ({ variant }: StatusDotProps): React.ReactElement => (
  <span className={`${styles.statusDot} ${styles[variant]}`} aria-label={variant} />
);

export { StatusDot };
export type { StatusDotVariant };
